export default "__VITE_ASSET__6IHRs8cJ__"